<app-checkout [onlineOrder]="onlineOrder"></app-checkout>


<div class="ct-container">
  <div class="ct-main-content">

    <hr/>
    <div class="online-order">
      <div class="status-container">
        <span class="status {{onlineOrder.status}}">
          {{onlineOrder.statusPtBr}}
        </span>
        <br/>
        @if (onlineOrder.reason) {
          <span class="reason">
            Motivo: {{onlineOrder.reason}}
          </span>
        }
      </div>

      <div class="contact-buttons">
        <app-contact-buttons [company]="onlineOrder.company" [whatsMsg]="whatsMsg"></app-contact-buttons>
      </div>

      <div class="back-button-container">
        <button class="btn btn-lg btn-secondary back-button" (click)="goBack()">Voltar</button>
      </div>
    </div>
  </div>
</div>